import { CustomAppLayout } from '../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useRef, useState } from 'react';
import { useRouter } from '../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../context/useStoreAdmin';

import { Cards, Link, SpaceBetween, StatusIndicator } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiPencilCircle } from '@mdi/js';
import Icon from '@mdi/react';
import Favorites from '../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { ItemBelt } from '../../../../resources/types';
import { addNotification, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../commons/functions';

export const ConfigBeltsPage = () => {
  //const storeAdmin = useStoreAdmin();
  const [stage, setStage] = useState("A")
  const [belts, setBelts] = useState<ItemBelt[]>([]);
  const [belt, setBelt] = useState<ItemBelt | null>(null);
  const { navigate } = useRouter();
  const { menu, idAirport } = useGlobalState();

  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const timer = setTimeout(() => {
      handleGetBelts();
    }, 500);
    return () => clearTimeout(timer);
  }, [idAirport]);


  const handleGetBelts = async () => { // Make the function async

    try {
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'JWT': getCookie("JWT"),
          'x-routing': '/private/config/belts/list',
        },
        body: JSON.stringify({}),

      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const dataWeb = await response.json();
      if (dataWeb.code == 0) {
        setBelts(dataWeb.belts);
      } else {
        addNotification(dataWeb.status, 'error', setData);
      }
    } catch (error: any) {
      addNotification(`Error al contactar el servidor: ${error.message}`, 'error', setData);

    } finally {
      setLoading(false)
    }
  };
  useEffect(() => {
    handleGetBelts();
  }, []);
  return (
    <CustomAppLayout
      toolsHide={true}
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <SpaceBetween size="s">
          <Header variant="h1" actions={<Favorites />}>{`Cintas de equipaje`}</Header>

          {belts && (
            <Cards
              key="belts-cards"
              cardDefinition={{
                header: item => (
                  <Header variant='h2'
                    actions={
                      <Link href={`#config/belts.edit?id=${item.idBelt}`} fontSize="heading-m"><Icon path={mdiPencilCircle} size={1} /></Link>
                    }
                  >

                    Cinta {item.belt}
                  </Header>
                ),
                sections: [
                  {
                    id: "idBelt",
                    header: "ID",
                    content: item => item.idBelt,
                    width: 50
                  },
                  {
                    id: "isActive",
                    header: "Estado",
                    content: item => item.isActiveBelt === 1 ? <StatusIndicator type="success">Activo</StatusIndicator> : <StatusIndicator type="error">Inactivo</StatusIndicator>,
                    width: 50
                  },
                ]
              }}
              cardsPerRow={[
                { cards: 1 },
                { minWidth: 500, cards: 3 }
              ]}
              items={(belts || []) as ItemBelt[]}
              trackBy="idBelt"
            />
          )}
        </SpaceBetween>
      }
    />
  )
};
